export const webStorageConfig = {
  sidebarCollapsed: {
    key: "sidebarCollapsed",
  },
  currentCompany: {
    key: "currentCompany",
  },
} as const;
